import { useTranslation } from 'react-i18next';
import AlbumAssoc from '../albums/AlbumAssoc';
import AlbumList from '../albums/AlbumList';
import { useAlbumList } from '../../api/queryHooks/pic';
import { useLogin } from '../../hooks/useLogin';
import { useShopState } from '../../hooks/useShopState';

export const AlbumOpenBlockView = () => <AlbumAssoc />;

// Stand-in for the two live album widgets in the admin preview: what they
// render depends on the visitor (and AlbumOpenBlockView brings its own
// <form>, which cannot be nested inside the page editor's form).
export const AlbumBlockPlaceholder = ({ type }: { type: 'album_open' | 'album_list' }) => {
  const { t } = useTranslation();
  return <p className="block-placeholder">{t(`admin.pages.blocks.type_${type}`)}</p>;
};

// A shop that isn't taking orders refuses album browsing (403), so the list
// is not even requested then; the paused notice says why.
export const AlbumListBlockView = () => {
  const { isLoggedIn } = useLogin();
  const { pausedForMe, isPending: shopStatePending } = useShopState();
  const browsable = isLoggedIn && !shopStatePending && !pausedForMe;
  const { data: albums } = useAlbumList(browsable);
  if (!browsable || !albums || albums.length === 0) return null;
  return <AlbumList albums={albums} title={null} closable />;
};
